
 export const videos = [
  {
    _id: "gcNGaTYwA3I",
    title: "4 Products in Your Kitchen You Should Throw Away (With Healthier Alternatives)",
    categoryName:"Health Awareness",
    views:"83K",
    creator:"Fit Tuber",
    channelProfile:"ytc/AMLnZu-e1AZQMfQgV6NMju1CBiycOZON54u7gs1AdRIo=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/gcNGaTYwA3I/maxresdefault.jpg",
    uploadedAt:new Date("Feb 25, 2022"),
    description:"In this video, I am going to share with you 4 kitchen products that you throw away immediately. Most of these products are used daily in Indian households and to know that these products pose some serious health hazards is really disturbing. It’s high time we talk about them as I can assure you that most of you would be using 3 out of these 4 products on a daily basis. We will discuss why these products are detrimental and how easily you can switch to healthier alternatives. ",   
  },

  {
    _id: "vqRBCa1Jv4w",
    title: "5 Natural Toothpastes in India Under Rs 219 that You Must Try (#3 is just Rs 70)",
    categoryName:"Health Awareness",
    views:"829K",
    creator:"Fit Tuber",
    channelProfile:"ytc/AMLnZu-e1AZQMfQgV6NMju1CBiycOZON54u7gs1AdRIo=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/vqRBCa1Jv4w/maxresdefault.jpg",
    uploadedAt:new Date("Jun 17, 2022"),
    description:"Brushing your teeth is an indispensable part of personal hygiene. However, it is even more important to choose a toothpaste which is free from harmful chemicals and is also pocket friendly. And if you thought that natural products are always expensive then let us break the myth as in this video I am going to share with you 5 toothpastes which are 100% safe and also under Rs 219. Look out for #3 as it is natural and yet cheaper than your current toothpaste. ",   
  },

  {
    _id: "rfscVS0vtbw",
    title: "Learn Python - Full Course for Beginners [Tutorial]",
    categoryName: "Programming",
    views:"35M",
    creator:"freeCodeCamp.org",
    channelProfile:"ytc/AMLnZu9UWrGceKWaqm8AF89vuxrEt8MO3E59qOoQ785Lew=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/rfscVS0vtbw/maxresdefault.jpg",
    uploadedAt:new Date("Jul 11, 2018"),
    description:"This course will give you a full introduction into all of the core concepts in python. Follow along with the videos and you'll be a python programmer in no time! Want more from Mike? He's starting a coding RPG/Bootcamp - https://simulator.dev/",   
  },

  {
    _id: "PkZNo7MFNFg",
    title: "Learn JavaScript - Full Course for Beginners",
    categoryName: "Programming",
    views:"10M",
    creator:"freeCodeCamp.org",
    channelProfile:"ytc/AMLnZu9UWrGceKWaqm8AF89vuxrEt8MO3E59qOoQ785Lew=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/PkZNo7MFNFg/maxresdefault.jpg",
    uploadedAt:new Date("Dec 10, 2020"),
    description:" This complete 134-part JavaScript tutorial for beginners will teach you everything you need to know to get started with the JavaScript programming language.",   
  },

  {
    _id: "lNvBXLbInXE",
    title: "7 Min Daily Yoga Routine for Beginners (Follow Along)",
    categoryName:"Health Awareness",
    views:"421K",
    creator:"Fit Tuber",
    channelProfile:"ytc/AMLnZu-e1AZQMfQgV6NMju1CBiycOZON54u7gs1AdRIo=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/lNvBXLbInXE/maxresdefault.jpg",
    uploadedAt:new Date("Jun 03, 2022"),
    description:"This is a 7 Minute daily yoga routine for beginners that you can easily do at home. It is compact yet extremely rejuvenating for the body and the mind. If you have never done any of the yogic breathing exercises or asanas then this can be a perfect start. One more thing, this video is not just to watch but to follow along.",   
  },
 
  {
    _id: "tz0fDABt67g",
    title: "Every Beginner React Developer Makes This Mistake With State",
    categoryName: "Programming",
    views:"163K",
    creator:"Web Dev Simplified",
    channelProfile:"ytc/AMLnZu-PjRc81p0qP-ZPWxv8aY4k-4gFRzGEYs3HWbIQ=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/tz0fDABt67g/maxresdefault.jpg",
    uploadedAt:new Date("Jun 25, 2022"),
    description:"By far one of the biggest beginner React mistakes I see is developers storing derived state. This is a huge problem that is incredibly hard to detect unless you know what you are looking for. In this video I will show you what the signs are of derived state so you can make sure you never store derived state.",   
  },

  {
    _id: "2md4HQNRqJA",
    title: "Welcome to new JavaScript course",
    categoryName: "Programming",
    views:"7.8k",
    creator:"Hitesh Choudhary",
    channelProfile:"ytc/AMLnZu--BW5u0yDUi9roKCJ5iW3NSFdvxTToEMOYzXjcyw=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/2md4HQNRqJA/maxresdefault.jpg",
    uploadedAt:new Date("Jul 05, 2022"),
    description:"Welcome to new JavaScript course.",   
  },

   {
    _id: "NkGhs_n1PCg",
    title: "Creating a Form for Adding Product | NextJs Tutorial for Beginners #78",
    categoryName: "Programming",
    views:"8K",
    creator:"CodeWithHarry",
    channelProfile:"ytc/AMLnZu8dZQJYCt6Ffcd-pl113huuo_HJ3PpvgkyFk5FkrQ=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/NkGhs_n1PCg/maxresdefault.jpg",
    uploadedAt:new Date("Jun 25, 2022"),
    description:"Creating a Form for Adding Product | NextJs Tutorial for Beginners #78.",   
  },

  

  {
    _id: "cO8cccJkQ1c",
    title: "20 Min Full Body Workout For Beginners (Follow Along) | Men & Women",
    categoryName:"Health Awareness",
    views:"1.7M",
    creator:"Fit Tuber",
    channelProfile:"ytc/AMLnZu-e1AZQMfQgV6NMju1CBiycOZON54u7gs1AdRIo=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/cO8cccJkQ1c/maxresdefault.jpg",
    uploadedAt:new Date("Oct 08, 2021"),
    description:"20 Minutes Full Body Daily Workout Routine for men and women that you can do at home. Total body workout for fat loss and muscle toning. ",   
  },

  {
    _id: "0cSVuySEB0A",
    title: "React Router v6 in depth guide",
    categoryName:"Programming",
    views:"567K",
    creator:"Hitesh Choudhary",
    channelProfile:"ytc/AMLnZu--BW5u0yDUi9roKCJ5iW3NSFdvxTToEMOYzXjcyw=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/0cSVuySEB0A/maxresdefault.jpg",
    uploadedAt:new Date("Nov 09, 2021"),
    description:"Welcome to react-router version 6 in-depth guide. In this video, we will learn about react-router v6 but creating a fresh project. I assume that you have no prior experience with react-router. In case you have, you will learn to upgrade your project from version 5 to version 6.",   
  },

  {
    _id: "TGHqBX1YJRc",
    title: "The Men who Built India | Untold Story of Tata | Dhruv Rathee",
    categoryName:"Social Awareness",
    views:"3M",
    creator:"Dhruv Rathee",
    channelProfile:"oQ2NQMuq-9IS6_MZdsGXa0RWecaACremA01Z7jo-YpoEF1H6PyUF8PZzXkV10OYwSP3UMJDeTg=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/TGHqBX1YJRc/maxresdefault.jpg",
    uploadedAt:new Date("Jul 04, 2022"),
    description:"Tata Group is considered one of India's most impactful companies not just in terms of how much it contributes to our country's economy, but also in terms of the values established by Jamsetji Tata which are still in place under the leadership of Ratan Tata. It originated in the era when India was in the hands of the Britishers and Independent Indian companies were not normalized. However, despite such hurdles, the strong vision and strategies led Tata to where it is today, and its story is worth listening to. Watch this video and get on a journey with Dhruv Rathee as he takes you back to the history of Tata, & how it shaped India as a nation.",   
  },

  {
    _id: "Iwz_Vdz8EKw",
    title: "Agneepath Scheme Explained | Good or Bad? | Agniveers | Dhruv Rathee ft.",
    categoryName:"Social Awareness",
    views:"5M",
    creator:"Dhruv Rathee",
    channelProfile:"oQ2NQMuq-9IS6_MZdsGXa0RWecaACremA01Z7jo-YpoEF1H6PyUF8PZzXkV10OYwSP3UMJDeTg=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/Iwz_Vdz8EKw/maxresdefault.jpg",
    uploadedAt:new Date("Jun 19, 2022"),
    description:"Agneepath Scheme or Agnipath Scheme 2022 is a new scheme introduced by the government to recruit the youth into the Indian Army for 4 years with a compensation of 30k per month. The recruited people would be known as Agniveers. However, there are some people who are protesting against this initiative. In fact, some of these protests have turned violent too. So what is the reality of this scheme? Are those protests valid? Watch this video to find out as I talk about the Agneepath scheme and the happenings revolving around it in detail.",   
  },

  {
    _id: "Wy017TbTzuY",
    title: "ITR Filing for salaried employees | Online Tutorial AY 2022-23 | Income Tax Return | LLA",
    categoryName:"Social Awareness",
    views:"576K",
    creator:"Labour Law Advisor ",
    channelProfile:"x1JSvmCagWY4M7yDxuf42ZjSUqY5RhomZsN35VIysRDlfwgbiHF3ygLw0DbA4j46BWxClqs3Gg=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/Wy017TbTzuY/maxresdefault.jpg",
    uploadedAt:new Date("Jul 26, 2022"),
    description:"This video is a step-by-step guide on how to file an Income tax Return Online for AY 2022-23 for a salaried employee. Who are eligible to file ITR 1? What comes under form 16 and form 26AS? We will also look at some of the tax deductions and exemptions. By the end of this video, I Jagruk RJ shared some of my ninja techniques which will help you file your ITR more efficiently.",   
  },

  {
    _id: "l3Acc3D8OH4",
    title: "[Secrets Revealed] How to find the BEST Health Insurance Policy? ft @B Wealthy",
    categoryName:"Social Awareness",
    views:"817K",
    creator:"Labour Law Advisor ",
    channelProfile:"x1JSvmCagWY4M7yDxuf42ZjSUqY5RhomZsN35VIysRDlfwgbiHF3ygLw0DbA4j46BWxClqs3Gg=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/l3Acc3D8OH4/maxresdefault.jpg",
    uploadedAt:new Date("Feb 03, 2021"),
    description:"Here it is, the much-awaited guide on how to find the best health insurance policy for yourself and your family",   
  },
  
  {
    _id: "WafKlTKUFyw",
    title: "Masterclass: Myanmar में Narendra Modi की मुश्किल का China ने क्या फायदा उठा लिया? Duniyadari E628",
    categoryName:"News",
    channelProfile:"ytc/AMLnZu95miw-xxKObNVp2GD5DlZrteukt1_12cDtOOVqHBQ=s68-c-k-c0x00ffffff-no-rj",
    views:"89K",
    creator:"The Lallantop",
    thumbnail:"https://img.youtube.com/vi/WafKlTKUFyw/maxresdefault.jpg",
    uploadedAt:new Date("Jul 30, 2022"),
    description:"In this episode, Saurabh Dwivedi discusses the Military Junta of Myanmar and its impact on India. Myanmar army did a military coup in the early hours of February 1st, 2021. The army arrested elected leaders like Aung Sang Suu Kyi and others and then announced a nationwide emergency. Despite the restrictions and violence, People continued to protest and kept criticising the Army. Thousands have been locked in jail and many killed in the broad daylight. Recently, Four democracy activists were hanged for their anti-military demonstrations. One of them was a former parliamentarian. He was a close ally of Suu Kyi. Capital punishment is legal yet rare in Myanmar. The previous capital punishment did happen some three decades before.",   
  },

   {
    _id: "GKyCVpBh_Zw",
    title: "जगभरात मंदीची लाट येईल अशी शक्यता असताना भारतात ही मंदी 0% असेल अस का म्हटलं जातयं | Bol Bhidu",
    categoryName:"News",
    views:"49K",
    creator:"Bol Bhidu",
    channelProfile:"8d6ERqjLo_XCYH-0DWBd9L4tNKEHgZNSGBlZsxpCPRi6BgdcJmGfwmidRBwS7J5gAmE8JWFx=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/GKyCVpBh_Zw/maxresdefault.jpg",
    uploadedAt:new Date("Jul 31, 2022"),
    description:"जगभरात सध्या मंदीची सुरूवात झालीये अस म्हटलं जातय. अनेक देश मंदीच्या उंबरठ्यावर आहेत. परंतु यामध्ये भारताबाबत जे भाकित केलं जातय त्यात या मंदीची जळ भारताला बसणार नाही अस म्हटलं जातय आणि भारतात ही मंदी 0% असेल अस म्हणतायत. तर हे कस काय? यामागची कारण काय आहेत? ",   
  },

  {
    _id: "7qrHperoAMA",
    title: "आणि नरेंद्र मोदींनी ठरवलं, आता गडकरींना दाखवून द्यायचं आपलं भाजपमध्ये किती वजन आहे.. | BolBhidu #BJP",
    categoryName:"News",
    views:"496K",
    creator:"Bol Bhidu",
    channelProfile:"8d6ERqjLo_XCYH-0DWBd9L4tNKEHgZNSGBlZsxpCPRi6BgdcJmGfwmidRBwS7J5gAmE8JWFx=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/7qrHperoAMA/maxresdefault.jpg",
    uploadedAt: new Date("May 22, 2022"),
    description:"अटलबिहारी वाजपेयी यांचं सरकार गेलं होतं. मनमोहनसिंग पंतप्रधान बनले होते. वयोमानामुळे वाजपेयीनी राजकारणातून संन्यास घेतल्यात जमा होती. त्यांचे वारस अडवाणी होते पण त्यानंतरचा नेता कोण असणार यात दुसऱ्या फळीमध्ये बरीच स्पर्धा होती. यात प्रमोद महाजन, सुषमा स्वराज, अरुण जेटली, नितीन गडकरी आघाडीवर होतेच. दरम्यान अजून एक नावही त्यावेळी नेहमी चर्चेत असायचं आणि या एका माणसामुळे नरेंद्र मोदी आणि नितीन गडकरी यांच्यात एका माणसामुळे जोरात पंगा झाला होता.. त्याचाच हा किस्सा. ",   
  },

  {
    _id: "6ADnDAsRxbU",
    title: "Prime Time With Ravish Kumar | Morbi पुल से जुड़ी Company के मालिक के सपनों का भारत",
    categoryName:"News",
    views:"436K",
    creator:"NDTV",
    channelProfile:"ytc/AMLnZu8QOjN67Remy83uzS8i7McoR84Wgs1o2VjcAXaafQ=s400-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://i.ytimg.com/vi/6ADnDAsRxbU/hqdefault.jpg",
    uploadedAt: new Date("Nov 04, 2022"),
    description:"Prime Time With Ravish Kumar - November 3, 2022: प्रधानमंत्री आवास योजना (PM Awas Yojana) के तहत लाभार्थियों को सौंप दिए गए 75 मकान लापता हो गए हैं. इस धनतेरस के दिन प्रधानमंत्री नरेंद्र मोदी (PM Narendra Modi) और मुख्यमंत्री शिवराज सिंह चौहान (CM Shivraj Singh Chouhan) ने कई लोगों को प्रधानमंत्री आवास योजना के तहत घर दिया. मध्य प्रदेश (Madhya Pradesh) के मुख्यमंत्री तो साक्षात मौजूद थे, प्रधानमंत्री नरेंद्र मोदी वीडियो कांफ्रेंसिंग से शामिल हुए थे। उस दिन जितने मकान दिए गए, उनमें से 75 मकान ग़ायब हो गए हैं, जिस आवास को प्रधानमंत्री मंत्री सौंप रहे हों और वह मकान ग़ायब हो जाए, इससे बड़ा घोटाला कुछ और नहीं हो सकता.  ",   
  },



  {
    _id: "qikxEIxsXco",
    title: "Closures in JS 🔥 | Namaste JavaScript Episode 10",
    categoryName:"Javascript",
    views:"337K",
    creator:"Akshay Saini",
    channelProfile:"ytc/AMLnZu-cSoO0e2Shro4sYkaKYCumlgllLCTYYNf7bk7G_g=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:  "https://img.youtube.com/vi/qikxEIxsXco/maxresdefault.jpg",
    uploadedAt:new Date("Dec 01, 2020"),
    description:"Closures in JavaScript is the most important topic for interviews. Even many senior frontend developers don't understand this concept properly.  This video will clear all your doubts about closures in js and you will never have to find any other tutorial after this to understand function Closure and Garbage collection. 🔥 ",   
  },

  {
    _id: "iv88UWteH5k",
    title: "PM Awas Yojana में घोटाला, Bank खाते के बिना भी लाभार्थियों को पैसे हुए Transfer | Khabron Ki Khabar",
    categoryName:"News",
    views:"20K",
    creator:"NDTV",
    channelProfile:"ytc/AMLnZu8QOjN67Remy83uzS8i7McoR84Wgs1o2VjcAXaafQ=s400-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/iv88UWteH5k/hqdefault.jpg",
    uploadedAt: new Date("Nov 03, 2022"),
    description:"मध्य प्रदेश (Madhya Pradesh) की शिवराज सिंह चौहान (Shivraj Singh Chouhan) सरकार प्रधानमंत्री आवास योजना (PM Awas Yojana) घोटाले में उलझ गई है. यहां ऐसे व्यक्तियों के नाम पर भी इस योजना के तहत आवास बांटे गए हैं, जिनकी मौत आज से 4-5 साल पहले हो चुकी है. धनतेरस के दिन बड़ा कार्यक्रम करके प्रधानमंत्री नरेंद्र मोदी (PM Narendra Modi) के हाथों साढ़े चार लाख गरीबों को पीएम आवास दिलाया गया था",   
  },

  {
    _id: "2WJL19wDH68",
    title: "JS Engine EXPOSED 🔥 Google's V8 Architecture 🚀 | Namaste JavaScript Ep. 16",
    categoryName:"Javascript",
    views:"174K",
    creator:"Akshay Saini",
    channelProfile:"ytc/AMLnZu-cSoO0e2Shro4sYkaKYCumlgllLCTYYNf7bk7G_g=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/2WJL19wDH68/maxresdefault.jpg",
    uploadedAt:new Date("Jan 10, 2021"),
    description:"In-depth explanation of JS Engine Architecture, JavaScript Runtime Environment, JIT compilation, Syntax Parsers, Garbage Collector, and how things work behind the scenes in Google's V8 JS Engine and its architecture.",   
  },

  {
    _id: "8zKuNo4ay8E",
    title: "Asynchronous JavaScript & EVENT LOOP from scratch 🔥 | Namaste JavaScript Ep.15",
    categoryName:"Javascript",
    views:"393K",
    creator:"Akshay Saini",
    channelProfile:"ytc/AMLnZu-cSoO0e2Shro4sYkaKYCumlgllLCTYYNf7bk7G_g=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/8zKuNo4ay8E/maxresdefault.jpg",
    uploadedAt:new Date("Dec 27, 2020"),
    description:"In-depth explanation of Event Loop, Web APIs, MicroTask Callback Queue, and how JavaScript works asynchronously in the web browser. Understand how setTimeout works behind the scenes along with fetch and event listeners. ",   
  },

  {
    _id: "nqsPmuicJJc",
    title: "TRUST ISSUES with setTimeout() | Namaste JavaScript Ep.17",
    categoryName:"Javascript",
    views:"117K",
    creator:"Akshay Saini",
    channelProfile:"ytc/AMLnZu-cSoO0e2Shro4sYkaKYCumlgllLCTYYNf7bk7G_g=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/nqsPmuicJJc/maxresdefault.jpg",
    uploadedAt:new Date("Jan 18, 2021"),
    description:" This BONUS video covers the fundamentals of setTimeout, how it works behind the scenes. We also discover that setTimeout does not guarantee that the callback method will be executed exactly after a certain delay. Hence, there are trust issues with setTimeout. 😅",   
  },

  {
    _id: "zdp0zrpKzIE",
    title: "map, filter & reduce 🙏 Namaste JavaScript Ep. 19 🔥",
    categoryName:"Javascript",
    views:"359K",
    creator:"Akshay Saini",
    channelProfile:"ytc/AMLnZu-cSoO0e2Shro4sYkaKYCumlgllLCTYYNf7bk7G_g=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/zdp0zrpKzIE/maxresdefault.jpg",
    uploadedAt:new Date("Jan 21, 2021"),
    description:"Map, filter & reduce Array functions are the most popular Higher-Order Functions in JavaScript.  This episode covers map(), filter() & reduce() along with 11 detailed code examples from easy to tricky ones(The last example is the Best). You'll also find homework towards the end of this episode. ❤️",   
  },

  {
    _id: "klnYxLLcceE",
    title: "India's Worst Plane Crash | Only Mid-Air Collision in History | Dhruv Rathee",
    categoryName:"Social Awareness",
    views:"3.7M",
    creator:"Dhruv Rathee",
    channelProfile:"oQ2NQMuq-9IS6_MZdsGXa0RWecaACremA01Z7jo-YpoEF1H6PyUF8PZzXkV10OYwSP3UMJDeTg=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/klnYxLLcceE/maxresdefault.jpg",
    uploadedAt:new Date("Apr 08, 2022"),
    description:"India witnessed the worst air crash in its history when 2 planes crashed in the air leading to the death of more than 300 people. This crash took place in a village named Charkhi Dadri near Delhi in 1996, and it became the deadliest case of its kind in the world. But what exactly happened? What was the cause of this crash? What were the findings of the Black Box? Watch this video to find out where I talk about the Charkhi-Dadri Mid Air Plane Collision and everything you need to know about it.",   
  },

 

  {
    _id: "weDmVu1SPuI",
    title: "9 Common Hygiene Mistakes That You Must Avoid",
    categoryName:"Health Awareness",
    views:"753K",
    creator:"Fit Tuber",
    channelProfile:"ytc/AMLnZu-e1AZQMfQgV6NMju1CBiycOZON54u7gs1AdRIo=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/weDmVu1SPuI/maxresdefault.jpg",
    uploadedAt:new Date("July 29, 2022"),
    description:" 9 Common Hygiene Mistakes That You Must Avoid.",   
  },

  {
    _id: "leIiFgI79Ek",
    title: "How Banks Earn Money? | Business Model of Banks | Dhruv Rathee",
    categoryName:"Social Awareness",
    views:"2M",
    creator:"Dhruv Rathee",
    channelProfile:"oQ2NQMuq-9IS6_MZdsGXa0RWecaACremA01Z7jo-YpoEF1H6PyUF8PZzXkV10OYwSP3UMJDeTg=s68-c-k-c0x00ffffff-no-rj",
    thumbnail:"https://img.youtube.com/vi/leIiFgI79Ek/maxresdefault.jpg",
    uploadedAt:new Date("Dec 28, 2021"),
    description:"Banks are often perceived as a money lending entity, but have you ever thought about how do Banks earn money? What is their Business Model? How do they provide you interest over your Deposits? What if all its customers want to withdraw their money at one time? I explain the economics behind how banks earn money and also explain some important concepts such as Cash Reserve Ratio (CRR), Statutory Liquid Ratio (SLR), Bank Run, Non Performing Assets (NPA), etc. in this video.",   
  }
  
];



